import { render, staticRenderFns } from "./configGlobal.vue?vue&type=template&id=981d447c&"
import script from "./configGlobal.vue?vue&type=script&lang=js&"
export * from "./configGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports